import { QueryKeys } from "../../../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../../../hooks/reactQuery/useQueryState";
import { useServiceTemplateApi } from "../../../../hooks/useServiceTemplateApi";
export const useServiceTemplatesForBilling = function useServiceTemplatesForBilling() {
  let {
    refreshOnMount
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const serviceTemplateApi = useServiceTemplateApi();
  const {
    data: serviceTemplates,
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.ServiceTemplatesForBilling],
    queryFn: () => serviceTemplateApi.getForBilling(),
    refreshOnMount
  });
  return {
    serviceTemplates: serviceTemplates !== null && serviceTemplates !== void 0 ? serviceTemplates : [],
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  };
};